import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Row, Col, FormGroup, Label, Input} from 'reactstrap';
import Select from 'react-select';
import {TabelaCadastro} from "../components/TabelaCadastro";
import ETTStore from "../stores/ETTStore";
import NumberFormat from "react-number-format";
import {arrayToString, createSelectOptions, formatarCnpj, formatarReal, getByAtribute} from "../../../utils/formatar";
import {Validacao} from "../../comum/components/Validacao";
import shortid from "shortid";
import {formatarData} from "../../../utils/functions";

@inject("store")
@DataWrapper
@observer
export class CadastroETT extends Component {
    constructor(props) {
        super(props);
        this.modal                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller                 = new ETTStore(this.modal);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("ETT");

        this.controller.carregarLista();
    }

    /* modais (body e botões) */
    modalForm = () => {
        const competenciaCargoOptions = createSelectOptions(this.controller.competenciasCargo, "nome", "nome");
        const usuarioCacheOptions = createSelectOptions(this.controller.itemSelecionado.usuarios, "login", "nome");
        const empresaGloboOptions = createSelectOptions(this.controller.empresasGlobo.filter(item => item.ativo), "id", ["nome"]);

        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup check >
                        <Label check>
                            <Input type="checkbox" checked={this.controller.itemSelecionado.ativo} onChange={() => this.controller.toggleAtivo()}/>{' '}
                            <Label>Ativo</Label>
                        </Label>
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>CNPJ <sup>*</sup></Label>
                        {this.modal.exibirModal.tipo === 'editar' ?
                            <NumberFormat className="form-control" format="##.###.###/####-##" value={this.controller.itemSelecionado.cnpj} onChange={(event, values) => this.controller.setCNPJ(values.value)} readOnly />  :
                            <div>
                                <NumberFormat className="form-control" format="##.###.###/####-##" value={this.controller.itemSelecionado.cnpj} onChange={(event, values) => this.controller.setCNPJ(values.value, this.modal.exibirModal.tipo)}/>
                                <Validacao id="cnpjExistente" valor={!this.controller.cnpjInexistente} tipo={["isBooleanRequired"]} mensagem={{isBooleanRequired: "CNPJ não cadastrado"}} />
                            </div>
                        }
                        <Validacao id="cnpj" valor={this.controller.itemSelecionado.cnpj} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Nome fantasia</Label>
                        <Input type="text" value={this.controller.itemSelecionado.nomeFantasia} onChange={(event) => this.controller.setNomeFantasia(event.target.value)} readOnly />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Razão social</Label>
                        <Input type="text" value={this.controller.itemSelecionado.razaoSocial} onChange={(event) => this.controller.setRazaoSocial(event.target.value)} readOnly/>
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Membros {this.controller.itemSelecionado.ativo && <sup>*</sup>}</Label>
                        <Select simpleValue cacheAsyncResults={false} options={usuarioCacheOptions} value={this.controller.itemSelecionado.usuarioLogins}
                                onChange={(value) => this.controller.setUsuarioLogin(value)}
                                searchPromptText="Informe nome para pesquisar" noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                asyncOptions={(input, callback) => this.controller.filtrarUsuarios(input, callback)} multi="true" />
                        {this.controller.itemSelecionado.ativo && <Validacao id="usuarioLogins" valor={this.controller.itemSelecionado.usuarioLogins} tipo={["isRequired"]} />}
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Competências</Label>
                        <Select simpleValue  value={this.controller.itemSelecionado.competenciaCargoIds} options={competenciaCargoOptions}
                                onChange={(value) => this.controller.setCompetenciasCargoIds(value)} multi={true}
                                placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <div className="form-title">
                        <h4>Contratos</h4>
                    </div>
                    <FormGroup>
                        <Label>Unidades de negócio (BUs)</Label>
                        <Select simpleValue  disabled={!this.controller.itemSelecionado.nomeFantasia}
                                value={this.controller.itemSelecionado.empresasGloboComContrato} options={empresaGloboOptions}
                                onChange={(value, option) => this.controller.setEmpresasGloboComContrato(value, option)}
                                noResultsText="Nenhum resultado encontrado" placeholder="Selecione..." multi={true}/>
                    </FormGroup>
                    <Row>
                    {this.controller.itemSelecionado.contratosEttGlobo && this.controller.itemSelecionado.contratosEttGlobo.map((contrato, index) => {
                        const ordensCompra = contrato.ordensCompra ? contrato.ordensCompra : [];
                        const loadingOcs = contrato.loadingListaOcs || contrato.loadingOCSelecionada;
                        const id = shortid.generate();
                        return (
                            <Col xs={12} key={index}>
                                <div className="form-subtitle">
                                    <span className="subtitle">{contrato.empresaGlobo && contrato.empresaGlobo.nome}</span>
                                </div>
                                <hr className="form-subtitle"/>
                                <Row>
                                    <Col xs={12} >
                                        <FormGroup>
                                            <Label>Taxa de administração <sup>*</sup></Label>
                                            <NumberFormat suffix="%" allowNegative={false} className="form-control" decimalPrecision={15} value={contrato.taxaAdministracao} onChange={(event, values) => this.controller.setTaxaAdministrativa(values.floatValue, index)}/>
                                            <Validacao id={"taxaAdministracao"+index} valor={contrato.taxaAdministracao} tipo={["isRequired"]} />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} >
                                        <FormGroup>
                                            <Label>Acordo <sup>*</sup></Label>
                                            <Select simpleValue  value={contrato.ordemSelecionada} options={ordensCompra}
                                                    valueKey="number"
                                                    labelKey="labelValue"
                                                    isLoading={loadingOcs}
                                                    onChange={(value) => this.controller.setNumeroOrdemCompra(value, getByAtribute(ordensCompra, value, "number"), index)}
                                                    noResultsText="Nenhum resultado encontrado" placeholder="Selecione..." multi={false}/>
                                            {contrato.ordemSelecionada &&
                                                <Validacao id={"ocValida" + index}
                                                           valor={contrato.ordemSelecionada.balance > 0 && contrato.ordemSelecionada.status === "OPEN"}
                                                           tipo={["isBooleanRequired"]}
                                                           mensagem={{isBooleanRequired: "Ordem de compra não está vigente ou não possui saldo"}}/>
                                            }

                                            <Validacao id={"ocRequired"+index} valor={contrato.numeroAcordo} tipo={["isRequired"]} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {contrato.ordemSelecionada &&
                                <FormGroup row>
                                    <Col xs={12}><span><strong>Data de criação</strong>: {formatarData(contrato.ordemSelecionada.creationDate)}</span></Col>
                                    <Col xs={12}><span><strong>Status</strong>: {contrato.ordemSelecionada.status}</span></Col>
                                    <Col xs={12}><span><strong>Número da revisão</strong>: {contrato.ordemSelecionada.revisionNumber}</span></Col>
                                    <Col xs={12}><span><strong>Saldo</strong>: {formatarReal(contrato.ordemSelecionada.balance)}</span></Col>
                                    <Col xs={12}><span><strong>Comentários</strong>: {contrato.ordemSelecionada.comments}</span></Col>
                                </FormGroup>
                                }
                            </Col>
                        )
                    })}
                    </Row>
                </Col>
            </Row>
        )
    };

    obterTituloMobile = (objeto) => {
        return objeto.nomeFantasia;
    };

    obterConteudoMobile = (objeto) => {
        const ativo = objeto.ativo ? "Sim" : "Não";
        return (
            <div>
                { "Razão social: " + objeto.razaoSocial}<br/>
                { "CNPJ: " + formatarCnpj(objeto.cnpj)}<br/>
                { "Membros: " + arrayToString(objeto.usuarios, "nome")}<br/>
                { "Competências: " + arrayToString(objeto.competenciasCargo, "nome")}<br/>
                { "Ativo: " + ativo}<br/>
            </div>
        )
    };

    nomesFormat(cell) {
        return arrayToString(cell, "nome")
    }

    cnpjFormat(cell) {
        return formatarCnpj(cell)
    }

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "nomeFantasia",
                label: "Nome fantasia"
            },{
                field: "razaoSocial",
                label: "Razão social"
            },{
                field: "cnpj",
                label: "CNPJ",
                dataFormat: this.cnpjFormat
            },{
                field: "usuarios",
                label: "Membros",
                dataFormat: this.nomesFormat
            },{
                field: "competenciasCargo",
                label: "Competências",
                dataFormat: this.nomesFormat
            },{
                field: "ativo",
                label: "Ativo",
                type: "boolean"
            }];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'ETT'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.ettList}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={true}
                            modalEditar={this.modalForm()}
                            modalCadastrar={this.modalForm()}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

